// extracted by mini-css-extract-plugin
module.exports = {"iyidwi2":"iyidwi2","c1tnpe3b":"c1tnpe3b","t956ht2":"t956ht2"};